/**
 * KaraokeCore logo — recoloured via CSS mask-image so the PNG file at
 * `/KaraokeCore by Nairoke Logo.PNG` stays untouched. The original purple
 * brand is replaced with the Backstage Console palette per `tone` prop.
 *
 * Pass `tone="original"` to render the unmodified purple PNG.
 */

type LogoTone = 'text' | 'primary' | 'signal' | 'ok' | 'original';
type LogoSize = 'sm' | 'md' | 'lg';

interface LogoProps {
  tone?: LogoTone;
  size?: LogoSize;
  className?: string;
}

const SIZE_CLASS: Record<LogoSize, string> = {
  sm: 'h-7 w-7',
  md: 'h-9 w-9',
  lg: 'h-12 w-12',
};

const TONE_VAR: Record<Exclude<LogoTone, 'original'>, string> = {
  text: 'var(--console-text)',
  primary: 'var(--console-primary)',
  signal: 'var(--console-signal)',
  ok: 'var(--console-ok)',
};

const Logo = ({ tone = 'text', size = 'md', className = '' }: LogoProps) => {
  const sizeClass = SIZE_CLASS[size];

  // Escape hatch — render original purple PNG with no recolour
  if (tone === 'original') {
    return (
      <img
        src="/KaraokeCore by Nairoke Logo.PNG"
        alt="KaraokeCore"
        className={`${sizeClass} object-contain rounded-[6px] ${className}`}
      />
    );
  }

  return (
    <div
      role="img"
      aria-label="KaraokeCore"
      className={`${sizeClass} rounded-[6px] shrink-0 ${className}`}
      style={{
        backgroundColor: TONE_VAR[tone],
        WebkitMaskImage: 'url("/KaraokeCore by Nairoke Logo.PNG")',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: 'url("/KaraokeCore by Nairoke Logo.PNG")',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
      }}
    />
  );
};

export default Logo;
